import IdentificationError from './IdentificationError';

export default IdentificationError;
